import { AgGridReact } from '@mint-lib/ag-grid/react';
import type { FC } from 'react';

import { LoadingCell } from '@mint-lib/ag-grid/components';
import {
  ClientSideRowModelModule,
  ColDef,
  LicenseManager,
  ModuleRegistry,
  type OverlayType,
} from '@mint-lib/ag-grid/enterprise';
import { createDefaultColumn } from '@mint-lib/ag-grid/factory';

import ActionCellSkeleton from './ActionCellSkeleton.jsx';

ModuleRegistry.registerModules([ClientSideRowModelModule]);
LicenseManager.setLicenseKey(import.meta.env.VITE_AG_GRID_LICENSE_KEY);

const columnDefs: ColDef[] = [
  {
    field: 'name',
  },
  {
    field: 'flowType',
  },
  {
    field: 'status',
  },
  {
    field: 'requester',
  },
  {
    field: 'approver',
    flex: 2,
  },
  {
    colId: 'actionCell',
    flex: 0,
    minWidth: 40,
    width: 40,
    resizable: false,
    cellClass: 'p-0!',
    headerComponent: null,
    cellRenderer: ActionCellSkeleton,
    loadingCellRenderer: ActionCellSkeleton,
  },
];

const defaultColDef: ColDef = createDefaultColumn({
  headerComponent: LoadingCell,
  cellRenderer: LoadingCell,
  loadingCellRenderer: LoadingCell,
  sortable: false,
  suppressHeaderMenuButton: true,
  suppressMovable: true,
  resizable: false,
  flex: 1,
});

const rowData = Array.from({ length: 6 }).map(() => ({
  value: null,
}));
const suppressedOverlays: OverlayType[] = [
  'loading',
  'noMatchingRows',
  'noRows',
  'exporting',
];

const TableSkeleton: FC = () => {
  return (
    <div className="grow rounded-lg border border-ui-tertiary shadow-md">
      <AgGridReact
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        rowData={rowData}
        suppressHeaderFocus
        suppressCellFocus
        loading={false}
        suppressOverlays={suppressedOverlays}
        suppressContextMenu
      />
    </div>
  );
};

export default TableSkeleton;
